import { Trans } from '@lingui/macro'
import { useDispatch } from 'react-redux'
import DebouncedTextField from 'app/views/forms/common/DebouncedTextField'

export const FormEditorScrollToOnStart = ({
  editMode,
  depth,
  typeProps,
  injectable,
  showPdfProps,
  ...props
}) => {
  const dispatch = useDispatch()
  if (!editMode) {
    return <div></div>
  }
  const { text, scrollToOnStartId } = typeProps

  return (
    <div>
      <DebouncedTextField
        value={scrollToOnStartId || ''}
        style={{ marginTop: 15, marginBottom: 5 }}
        fullWidth
        label={<Trans>FORM_EDITOR_SCROLL_TO_ON_START_ID_LABEL</Trans>}
        variant='outlined'
        onChange={(e) => {
          const toSet = { ...typeProps }
          toSet.scrollToOnStartId = e.target.value
          if (!e.target.value) {
            delete toSet.scrollToOnStartId
          }
          dispatch({
            type: 'FIELD',
            injectable,
            depth: depth.split('.'),
            fieldName: 'typeProps',
            fieldValue: { ...toSet }
          })
        }}
      />
    </div>
  )
}
